import { DOMAIN_TITLE, WWW_IMAGE_PATH } from '../config/env';

export function debounce (fn, delay) {
    var timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;

        timeoutID = setTimeout(function () {
              fn.apply(that, args);
        }, delay);
    }
}

export default {
    methods: {
        $updatePageTitle(to, from) {
            let pageTitle = to.matched.find(item => item.meta.title);
            (pageTitle) ? window.document.title = pageTitle.meta.title : window.document.title = DOMAIN_TITLE;
        },
        
        $scrollToTop(){
            window.scrollTo(0,0);
        },
        $tomorrowDate() {
            var today = new Date();
            var tomorrow = new Date();
            tomorrow.setDate(today.getDate()+1); 
            return tomorrow;
        },
        $getNavItem(value){
            return this.$getItemFromContents("navigation", value).text;            
        },
        $getItemFromContents(contentId, itemName , customLng) {
            var contents = this.$store.state.contents[contentId];
            var lng =(!customLng) ? this.$getLng() : customLng;
            //console.log("getItemFromContents =>" + contentId + " -> " + itemName + " " + contents.length + ' => ' + lng);
            
            if (this.$checkNull(contents))
            {
                var res = contents.find(item => item.label == itemName );
                if (this.$checkNull(res))
                {
                    res[lng]['images'] = res.images;
                    return res[lng];
                }
                console.log(itemName + " doesn't exist");
                return false;

            }
            else
            {
                console.log("contents empty for " + contentId  + " => " + itemName);
                return false;
            }
        },
        $getMetaTag(page){
            return {
                title: this.$getItemFromContents(page, "meta_titre").text,
                    //titleTemplate: '%s - Yay!',
                htmlAttrs: {
                    lang: this.$getLng(),
                    amp: false
                },
                meta: [
                    { name: 'description', content: this.$getItemFromContents(page, "meta_description").text, },
                ],      
            };
        
        },
        /*
        $validityCheck(context) {
            setInterval(() => {
                if (context.formstate.$invalid) {
                    context.requiredMsg = 'Remplissez les champs requis SVP';
                    context.disabled = true;
                } else {
                    context.requiredMsg = '';
                    context.disabled = false;
                }
            }, 1000)
        },*/
        $checkNull(value) {
            if (value === '' || value === false || value === null || value === 'undefined' || value === undefined) {
                return false;
            }
            return true;
        },
        
        $checkMobileFormat(){
            if (this.$store.getters.getWindowSize.width < 768) 
                return true;
            return false;
        },
        
        $toggleCurrentLanguage(){
            this.$store.state.lngFront = (this.$store.state.lngFront == 'fr') ? this.$store.state.lngFront = 'en' : this.$store.state.lngFront = 'fr';
            this.$changeLngUrl();
            //this.$route.params.extLng = this.$store.state.lngFront;
        }, 
        $goTo(path){
            return '/' + this.$getLng() +  '/' + path;
        },
        $changeLngUrl(){
            var uri = (this.$getLng() == "fr") ? "1" : "2";
            var supp = "?" + uri + this.$route.path.charAt(1) + "#";
            
            if ( this.$route.path == "/")
                history.pushState({},null, supp + "/" + this.$getLng()); 
            else
                history.pushState({},null, supp + this.$route.path.replace(/\/(fr|en)$/g, '') + "/" + this.$getLng()); 
        },
        $getLng(){
            return this.$store.getters.currentLng;
        },
        $checkSearchString(searchValue){
            //-- replace invalid chars
           searchValue = searchValue.replace(/[^a-zA-Z0-9éàèê ]/g, '');
           if (!this.$checkNull(searchValue) ||searchValue.length < 3) 
               return false;
           else
               return searchValue;
        },
        $selectFilterHeading(refId){
            
            //var div = this.$refs[refId];
            var div =document.getElementById(refId);
            var width = div.clientWidth - 5;
            var height = 25;
           var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="'+ width+3 +'" height="'+ height+3 +'" viewBox="0 0 '+ width+3 +' '+ height +3 +'" preserveAspectRatio="none"><defs><style>.cls-1{fill: #fff;}.cls-1, .cls-2 {stroke: #00676c;stroke-width: 1px;}.cls-2 {fill: #00676c;}</style></defs><rect id="Rectangle_12_copie_2" data-name="Rectangle 12 copie 2" class="cls-1" x="3" y="3" width="'+ width +'" height="'+ height +'"/>  <rect id="Rectangle_12_copie_2-2" data-name="Rectangle 12 copie 2" class="cls-2" width="'+ width +'" height="'+ height +'"/></svg>';
           //var svg = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  width="320px" height="100px" viewBox="0 0 320 100" enable-background="new 0 0 320 100" xml:space="preserve"> <polygon class="mystar" fill="#'+green+'" points="134.973,14.204 143.295,31.066 161.903,33.77 148.438,46.896 151.617,65.43 134.973,56.679 118.329,65.43 121.507,46.896 108.042,33.77 126.65,31.066 "/><circle class="mycircle" fill="#'+red+'" cx="202.028" cy="58.342" r="12.26"/></svg>';		
            var encoded = window.btoa(svg);
            div.style.backgroundImage = "url(data:image/svg+xml;base64,"+encoded+")";
            div.style.backgroundSize = "100% 30px;";
            div.style.color = "white";
            //console.log("selectFilter modifying style ->" + refId + " width:" + width);
            return refId;
        },
        
         $selectFilterCat(refId){
            
            //var div = this.$refs[refId];
            var div =document.getElementById(refId);
            var width = div.clientWidth - 5;
            var height = 25;
           var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="'+ width+3 +'" height="'+ height+3 +'" viewBox="0 0 '+ width+3 +' '+ height +3 +'" preserveAspectRatio="none"><defs><style>.cls-1{fill: #fff;}.cls-1, .cls-2 {stroke: #00676c;stroke-width: 1px;}.cls-2 {fill: #00676c;}</style></defs><rect id="Rectangle_12_copie_2" data-name="Rectangle 12 copie 2" class="cls-1" x="3" y="3" width="'+ width +'" height="'+ height +'"/>  <rect id="Rectangle_12_copie_2-2" data-name="Rectangle 12 copie 2" class="cls-2" width="'+ width +'" height="'+ height +'"/></svg>';
           //var svg = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  width="320px" height="100px" viewBox="0 0 320 100" enable-background="new 0 0 320 100" xml:space="preserve"> <polygon class="mystar" fill="#'+green+'" points="134.973,14.204 143.295,31.066 161.903,33.77 148.438,46.896 151.617,65.43 134.973,56.679 118.329,65.43 121.507,46.896 108.042,33.77 126.65,31.066 "/><circle class="mycircle" fill="#'+red+'" cx="202.028" cy="58.342" r="12.26"/></svg>';		
            var encoded = window.btoa(svg);
            div.style.backgroundImage = "url(data:image/svg+xml;base64,"+encoded+")";
            div.style.backgroundSize = "100% 30px;";
            div.style.color = "white";
            //console.log("selectFilter modifying style ->" + refId + " width:" + width);
            return refId;
        },
        
        $initBackToTopBtn(){
            //-- Remove button
            let btn = document.getElementById('back-to-top-container');
            btn.classList.remove('show');
            //-- Check scroll for the backToTop button
            document.getElementById('router-container').onscroll = function() {
                let scrollSize = document.getElementById('router-container').scrollTop;
                let btn = document.getElementById('back-to-top-container');
                //console.log(scrollSize);
                if (scrollSize > 50) 
                    btn.classList.add('show');
                else
                    btn.classList.remove('show');
            };              
        },
        
        $loadMore(marge, callback){
            //-- Check scroll for the backToTop button
            document.getElementById('router-container').addEventListener('scroll', function() {
                let scrollSize = document.getElementById('router-container').scrollTop + document.getElementById('router-container').offsetHeight + marge;
                let screenHeight = document.getElementById('router-container').scrollHeight;
                //console.log(scrollSize +" >= " +screenHeight);
                if (scrollSize >= screenHeight) 
                {
                    callback();
                }
            });              
        },
       

        $formatDateUs(date) {
            var startingDate = new Date(date);
            if (startingDate == 'Invalid Date') return;
            return startingDate.getFullYear() + "-" + (startingDate.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "-" + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
        },
        $formatDateNews(date) {
            var startingDate = new Date(date);
            if (startingDate == 'Invalid Date') return;
            return startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "." + ( (startingDate.getMonth() + 1) ).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "." + startingDate.getFullYear();
        },        
        $formatDateTimeFr(date) {
            //-- date must be US YYYY/MM/DD HH:MM
            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString('fr-fr', { month: 'short' });
            var day = startingDate.toLocaleString('fr-fr', { weekday: 'short' });
            var dayInt = startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var hours = startingDate.getHours().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var minutes = startingDate.getMinutes().toLocaleString(undefined, { minimumIntegerDigits: 2 });

            return day + ' ' + dayInt + ' ' + month + ' ' + startingDate.getFullYear() + ' ' + hours + ':' + minutes;
        },
        $formatDateFr(date, noWeekDay = false) {
            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString("fr-fr", { month: "short" });
            var day = (noWeekDay) ? startingDate.toLocaleString("fr-fr", { weekday: "short" }) : '';
            return day + " " + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }) + " " + month + " " + startingDate.getFullYear();
        },
        $processExecMsg(data) {
            if (!this.$checkNull(data))
                this.$Notification.error(data.replace(/<[^>]+>/g, ''));
            else
                if (this.$checkNull(data.result)) {
                    const code = data.result.code;
                    const msg = data.result.msg;

                    if (code == '100')
                    {
                        this.$Notification.success(`${msg}`);
                        return true;
                    }
                    else
                        this.$Notification.warn(`${msg}`);
                } else {
                    //-- No return formated, displaying raw result | removing html
                    this.$Notification.error(data.replace(/<[^>]+>/g, ''));
                }
            
            return false;
        },
        $test(){
                 this.$Notification.warn("test");
        },
        $processDataMsg(data) {
            if (this.$checkNull(data.code)) {
                //this.$Notification.warn(`Code: ${data.code} || Msg: ${data.msg}`)
                this.$Notification.warn(`${data.msg}`)
                return false;
            }
            else
                return true;
        },
        $formatBytes(bytes, decimals = 2) {
            if (bytes === 0) return '0 Bytes';

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        $preloadImages(urls, allImagesLoadedCallback){
            var loadedCounter = 0;
            var toBeLoadedNumber = urls.length;
            urls.forEach((url) => {
                this.$preloadImage(url, function(){
                    loadedCounter++;
                    //console.log('Number of loaded images: ' + loadedCounter);
                    if(loadedCounter == toBeLoadedNumber){
                        allImagesLoadedCallback();
                    }
                });
            });
        },        
         $preloadImage(url, anImageLoadedCallback){
             var img = new Image();
             img.onload = anImageLoadedCallback;
             img.src = url;
         },
        $hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
        $existValueArrays(tab1, tab2) {
            if (!Array.isArray(tab1)) return false;
            if (!Array.isArray(tab2)) tab2 = [tab2];
            var rs = false;
            if (this.$checkNull(tab1)) {
                for (var i = 0; i < tab1.length; i++) {
                    if (this.$checkNull(tab2))
                        tab2.forEach((item) => {
                            if (tab1[i] == item)
                                rs = true;
                        });
                    if (rs) return true;
                }
            }
        },

    }
}



// WEBPACK FOOTER //
// ./src/mixins/helpers.js